import { styled } from '@mui/material'

export const ButtonRecurrenceView = styled('button')(() => ({
  all: 'inherit',
  borderRadius: 999,
  cursor: 'pointer'
}))
